/* eslint-disable @angular-eslint/directive-class-suffix */
import { OnInit, OnDestroy, AfterViewInit, Directive } from '@angular/core';
import { PageType, PlatformHeadrId, SiteViewConfiguration, TimeFilter } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { ITicketDialogModel } from 'src/app/models/ticket-validation/ticketDialogModel.interface';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from 'src/app/services/util/utility.service';
import { EventsService } from 'src/app/services/events.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SportsService } from 'src/app/services/sports.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { DeployParams } from 'src/app/deployParams';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { UserService } from 'src/app/services/user.service';
import { TicketManagerUserService } from 'src/app/ticket-manager/services/ticketManagerUser.service';
import { IUserTM } from 'src/app/ticket-manager/models/user/userTM.interface';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { environment } from 'src/environments/environment';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class BettingBase implements OnInit, OnDestroy, AfterViewInit {
  pageType: PageType;
  // showStream = false;
  expandedEvent: EventVM = null;
  expandedEventResult: IEventResult = null;
  pageTypeEnum = PageType;
  isMobileView = false;

  // testing
  menu: any;
  buttons: any;
  lists: any;
  ticketDialogModel: ITicketDialogModel = null;

  loading: boolean;
  timeFilterValue: TimeFilter;
  timeFilterValueEnum = TimeFilter;
  viewConfigurations = ViewConfigurations;
  showH2Hwidget = false;
  showMPwidget = false;
  betRadarEventId: number;
  // tmUser: IUserTM;
  // affiliate: IAffiliate;
  // affiliateRoleEnum = AffiliateRole;

  protected subscription: Subscription = new Subscription();

  constructor(
    protected route: ActivatedRoute,
    protected utilityService: UtilityService,
    protected eventsService: EventsService,
    protected notificationService: NotificationService,
    protected sportsService: SportsService,
    protected loaderService: LoaderService,
    protected queryParamService: QueryParamsService,
    protected userService: UserService,
    protected ticketManagerUserService: TicketManagerUserService,
    protected authentificationService: AuthenticationService) {
    this.subscription.add(this.eventsService.expandedEvent$.subscribe((ev) => {
      this.expandedEvent = ev;
      this.showH2Hwidget = false;
      this.showMPwidget = false;
    }));
    this.subscription.add(this.notificationService.ticketDialogData$.subscribe((d) => {
      this.ticketDialogModel = d;
    }));
    // this.eventsService.showStream$.subscribe((x) => this.showStream = x);

    this.isMobileView = this.utilityService.mobileView;
    // this.subscription.add(this.queryParamService.pageTypeChanged$.subscribe((pt) => this.pageType = pt));

    this.subscription.add(this.sportsService.timeFilterChanged$.subscribe((x) => this.timeFilterValue = x));

    this.subscription.add(this.eventsService.headToHeadBetRadarEventIdChanged$.subscribe((betRadarId) => {
      // if (identifier !== this.betRadarEventId) {
      if (betRadarId !== -1) {
        this.showH2Hwidget = true;
        this.betRadarEventId = betRadarId;
      } else {
        this.showH2Hwidget = false;
      }
    }));

    this.subscription.add(this.eventsService.matchPreviewWidgetChanged$.subscribe((betRadarId) => {
      // if (identifier !== this.betRadarEventId) {
      if (betRadarId !== -1) {
        this.showMPwidget = true;
        this.betRadarEventId = betRadarId;
      } else {
        this.showMPwidget = false;
      }
    }));

    this.subscription.add(this.eventsService.expandedEventResult$.subscribe((ev) => this.expandedEventResult = ev));

    // this.subscription.add(this.ticketManagerUserService.tmUserChangedSource$.subscribe(() => this.tmUser = ticketManagerUserService.user));
    // this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => this.affiliate = this.authentificationService.loggedAffiliate));
  }

  ngOnInit(): void {
    // this.tmUser = this.ticketManagerUserService.user;
    // this.affiliate = this.authentificationService.loggedAffiliate;
    // this.route.paramMap.pipe(
    //   switchMap(params => {
    //     const id = +params.get('matchType');
    //     return params.get('matchType');
    //   })
    // );
    this.queryParamService.pageTypeChanged$.subscribe(pageType => {
      this.pageType = pageType;
      this.pageTypeChanged();
   });

    // this.param = this.route.snapshot.paramMap.get('matchType');

    this.subscription.add(this.loaderService.showHideLoader$.subscribe((x) => {
      setTimeout(() => {
        // console.log('loader ' + x);
        this.loading = x;
        // this.setLoaderPosition();
        // if (this.loading) {
        //   this.disableParentScroll();
        // } else {
        //   this.enableParentScroll();
        // }
      });
    }));
  }

  setLoaderPosition() {
    if (document.getElementById('loader') === null) { return; }
    const loader = document.getElementById('loader');
    // let scrollTop = environment.localDeploy ? 0 : window.parent.scrollY;
    const scrollTop = 0;
    // const scrollTop = environment.localDeploy ? 0 : window.parent.document.getElementById('container').scrollTop;
    const windowHeight = window.parent.innerHeight;

    const top = scrollTop + (windowHeight - loader.offsetHeight) / 2;
    loader.style.top = top + 'px';
    // this.disableParentScroll();

    // setTimeout(() => {
    //   loader.style.opacity = '1';
    //   loader.style.transition = 'none';
    // }, 200);

  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';
  }

  enableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'auto';
  }

  ngAfterViewInit(): void {
    // this.loading = false;
    const root = document.documentElement;
    this.menu  = document.getElementsByClassName('color-palet')[0];
    if (this.menu !== undefined){
      this.buttons = document.querySelectorAll('.color-palet-wrap .buttons')[0];
      // this.lists = document.querySelectorAll('.color-palet-wrap .buttons button');

      this.menu.addEventListener('click', e => {
        this.buttons.classList.toggle('show');
      });

      const themeBtns = document.querySelectorAll('.color-palet-wrap .buttons button');
      themeBtns.forEach(btn => {
        btn.addEventListener('click', test);
      });

      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      function test(e) {
        root.className = '';
        switch (e.target.value) {
          case 'dark':
            root.classList.add('dark');
            break;
          case 'red':
            root.classList.add('red');
            break;
          case 'light':
            root.classList.add('light');
            break;
          case 'blue':
            root.classList.add('blue');
            break;
        }
      }

    }
  }


  protected pageTypeChanged(){}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
